// In this file, all Page components from 'src/pages` are auto-imported. Nested
// directories are supported, and should be uppercase. Each subdirectory will be
// prepended onto the component name.
//
// Examples:
//
// 'src/pages/HomePage/HomePage.js'         -> HomePage
// 'src/pages/Admin/BooksPage/BooksPage.js' -> AdminBooksPage
import { Private, Route, Router, Set } from '@redwoodjs/router'

import { PageTitleProvider } from 'src/contexts/PageTitleContext'
import ArtistLayout from 'src/layouts/ArtistLayout'
import JoinLayout from 'src/layouts/JoinLayout'

const Routes = () => {
  return (
    <Router>
      <Set wrap={[JoinLayout]}>
        <Route path="/" page={HomePage} name="home" />
        <Route path="/welcome" page={WelcomePage} name="welcome" />
        <Route path="/join" page={JoinPage} name="join" />
        <Route path="/login" page={LoginPage} name="login" />
        <Route path="/reset-password" page={PasswordResetPage} name="passwordReset" />
      </Set>

      <Private unauthenticated="home" wrap={[JoinLayout]}>
        <Route path="/artist/create" page={ArtistCreatePage} name="artistCreate" />
      </Private>
      <Set private unauthenticated="home" wrap={[PageTitleProvider, ArtistLayout]}>
        <Route path="/artist" page={ArtistHomePage} name="artistHome" />
        <Route path="/artist/{slug}" page={ArtistHomePage} name="artistHome" />
        <Route path="/artist/{slug}/song/{songId:Int}" page={ArtistSongDetailPage} name="artistSongDetail" />
        <Route path="/artist/{slug}/song/{songId:Int}/lyrics" page={ArtistSongLyricsLogPage} name="artistSongLyricsLog" />
        <Route path="/artist/{slug}/song/{songId:Int}/lyrics/timeline" page={ArtistSongLyricsTimelinePage} name="artistSongLyricsTimeline" />
        <Route path="/artist/{slug}/analytics" page={ArtistAnalyticsSummaryPage} name="artistAnalyticsSummary" />
        <Route path="/settings/account" page={AccountSettingsPage} name="accountSettings" />
        <Route path="/fan-dashboard" page={FanDashboardPage} name="fanDashboard" />
      </Set>
      <Route path="/404" page={CustomErrorPage} name="notfound" />
      <Route path="/error" page={CustomErrorPage} name="error" />
      <Route notfound page={CustomErrorPage} />
    </Router>
  )
}

export default Routes
